import {Typography} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import {MdOutlineArrowForwardIos} from 'react-icons/md';
import {shallowEqual, useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';
import {TrackEventUBA, deferTask} from '@jobseeker/common-core/utils';

import type {MenuItemType, Props} from '../types';

const NestedMenu = (props: Props) => {
  const {open, anchorEl, menuItems = [], handleMenuClose, menuType} =
    props || {};
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const trackEvent = (item: MenuItemType) => {
    const section = menuType === 'course' ? 'Course' : 'Category';
    TrackEventUBA('topMenuClick', 'click', {
      section,
      categoryID: menuType === 'course' ? undefined : item?.dataId,
      page,
      sessionUsername: sessionStorage.getItem('userId') || '',
      clickedMenuName: item?.label,
    });
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      id="menu-nested-list-grow"
      placement="bottom-start"
      sx={{
        paddingTop: '5px',
        width: '200px',
      }}
    >
      <Paper>
        <MenuList>
          {menuItems.map((item, index) => (
            <MenuItem
              key={`lotus-menu-menuitem-${index}`}
              onClick={() => {
                deferTask(() => {
                  trackEvent(item);
                  handleMenuClose();
                });
              }}
            >
              <Typography variant="inherit">{item.label}</Typography>
              <MdOutlineArrowForwardIos style={{marginLeft: 'auto'}} />
            </MenuItem>
          ))}
        </MenuList>
      </Paper>
    </Popper>
  );
};

export default NestedMenu;
